var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 46.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.27,23l-10-9L26.47,2.4a2.2,2.2,0,0,0-2.94,0L10.75,13.93l-10,9a2.19,2.19,0,0,0,1.46,3.82H5.24A1.49,1.49,0,0,1,5.92,28V46.64a1.53,1.53,0,0,0,1.53,1.52H17.83a1.52,1.52,0,0,0,1.52-1.52V33.51A1.53,1.53,0,0,1,20.88,32h7.94a1.52,1.52,0,0,1,1.52,1.52V46.64a1.52,1.52,0,0,0,1.53,1.52H42.25a1.52,1.52,0,0,0,1.52-1.52V28a1.48,1.48,0,0,1,.69-1.24h3.35A2.19,2.19,0,0,0,49.27,23Z",
    transform: "translate(0 -1.84)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2f55219ac7451658ec0de1040b92f6df.svg";
export { ForwardRef as ReactComponent };